// グループ・クリエイターミックスリストのtype
export const CreatorTeamType = {
  team: { value: 'team' },
  creator: { value: 'creator' },
} as const;
export type CreatorTeamTypeType = keyof typeof CreatorTeamType;

export type CreatorTeamMixListItem = {
  id: number;
  name: string;
  urlSlug: string;
  iconUrl: string;
  type: CreatorTeamTypeType;
};

export type CreatorListItem = {
  id: number;
  name: string;
  urlSlug: string;
  iconUrl: string;
  bizTeam: Array<{ id: number; urlSlug: string; name: string }>;
};

export type BizCreatorLinkItem = {
  type: string;
  url: string;
};

export type BizCreatorDetail = {
  id: number;
  name: string;
  urlSlug: string;
  iconUrl: string;
  links: Array<BizCreatorLinkItem>;
  profileText: string;
  bizTeam: { id: number; urlSlug: string; name: string };
};

export type TeamListItem = {
  id: number;
  name: string;
  urlSlug: string;
  iconUrl: string;
};

export type BizTeamDetail = {
  id: number;
  name: string;
  urlSlug: string;
  iconUrl: string;
  links: Array<BizCreatorLinkItem>;
};

// ECアイテムタイプ
export const EcItemType = {
  image: {
    value: 'image',
    text: 'デジタルフォト',
    engText: 'Photo',
    prevText: '画像を表示する',
    downloadText: '画像をダウンロードする',
  },
  video: {
    value: 'video',
    text: 'デジタルムービー',
    engText: 'Movie',
    prevText: '動画を再生する',
    downloadText: '動画をダウンロードする',
  },
  audio: {
    value: 'audio',
    text: 'デジタルボイス',
    engText: 'Voice',
    prevText: '音声を再生する',
    downloadText: '音声をダウンロードする',
  },
} as const;
export type EcItemTypeType = keyof typeof EcItemType;

// ECアイテムメッセージタイプ
export const EcItemMessageType = {
  message: { value: 'message', text: 'メッセージ付き', engText: 'Message' },
  general: { value: 'general', text: '', engText: '' },
} as const;
export type EcItemMessageTypeType = keyof typeof EcItemMessageType;

// ECアイテム販売ステータス
export const EcItemSaleStatus = {
  upcoming: { value: 'upcoming', labelColor: 'cobaltblue' },
  on_sale: { value: 'on_sale', labelColor: 'primary' },
  later: { value: 'later', labelColor: 'pinkishgray' },
  sold: { value: 'sold', labelColor: 'warmgray' },
} as const;
export type EcItemSaleStatusType = keyof typeof EcItemSaleStatus;

// グループ・クリエイター種別
export const BizTeamCreatorType = {
  creator: { value: 'creator' },
  team: { value: 'team' },
} as const;
export type BizTeamCreatorTypeType = keyof typeof BizTeamCreatorType;

export type EcItemListItem = {
  id: number;
  productId: string;
  name: string;
  imageUrl: string;
  saleStartAt: string;
  saleEndAt: string;
  bizCreatorId: number;
  bizCreatorName: string;
  bizCreatorImageUrl: string;
  type: EcItemTypeType;
  isMessage: boolean;
  stock: number;
  currentStock: number;
  taxIncludedPrice: number;
  status: EcItemSaleStatusType;
};

export type EcItemDetailType = {
  id: number;
  productId: string;
  name: string;
  description: string;
  imageUrl: string;
  saleStartAt: string;
  saleEndAt: string;
  bizTeam: Array<{ id: number; name: string; slug: string }>;
  bizCreatorId: number;
  bizCreatorName: string;
  bizCreatorImageUrl: string;
  bizCreatorSlug: string;
  type: EcItemTypeType;
  isMessage: boolean;
  taxIncludedPrice: number;
  stock: number;
  currentStock: number;
  status: EcItemSaleStatusType;
};

// 購入済みECアイテムメッセージ入力ステータス
export const EcItemPurchasedMessageStatus = {
  unset: { value: 'unset' },
  pending: { value: 'pending' },
  approved: { value: 'approved' },
  reject: { value: 'reject' },
} as const;
export type EcItemPurchasedMessageStatusType = keyof typeof EcItemPurchasedMessageStatus;

// 購入済みECアイテム配送ステータス
export const EcItemPurchasedDeliveryStatus = {
  unset: { value: 'unset', text: '準備中' },
  pending: { value: 'pending', text: '準備中' },
  reject: { value: 'reject', text: '準備中' },
  delivered: { value: 'delivered', text: '納品済み' },
  read: { value: 'read', text: '納品済み' },
} as const;
export type EcItemPurchasedDeliveryStatusType = keyof typeof EcItemPurchasedDeliveryStatus;

// 納品ファイル変換ステータス
export const EcItemPurchasedFileStatus = {
  uploading: { value: 'uploading' },
  processing: { value: 'processing' },
  complete: { value: 'complete' },
  failed: { value: 'failed' },
} as const;
export type EcItemPurchasedFileStatusType = keyof typeof EcItemPurchasedFileStatus;

export type EcItemPurchasedHistoryItem = {
  id: number;
  productId: number;
  name: string;
  type: EcItemTypeType;
  imageUrl: string;
  blurredImageUrl: string;
  isMessage: boolean;
  displayStartAt: string;
  displayEndAt: string;
  saleStartAt: string;
  saleEndAt: string;
  taxIncludedPrice: number;
  bizCreatorId: number;
  bizCreatorName: string;
  bizCreatorImageUrl: string;
  messageStatus: EcItemPurchasedMessageStatusType;
  deliveryStatus: EcItemPurchasedDeliveryStatusType;
  createdAt: string;
  updatedAt: string;
  messageEndAt: string;
};

export type EcItemPurchasedHistoryDetailType = {
  id: number;
  productId: number;
  name: string;
  type: EcItemTypeType;
  description: string;
  files: {
    type: string;
    url: string;
    thumbnailUrl: string;
    blurredThumbnailUrl: string;
    status: EcItemPurchasedFileStatusType;
  };
  isMessage: boolean;
  displayStartAt: string;
  displayEndAt: string;
  saleStartAt: string;
  saleEndAt: string;
  taxIncludedPrice: number;
  bizTeam: Array<{ id: number; name: string; slug: string }>;
  bizCreatorId: number;
  bizCreatorName: string;
  bizCreatorImageUrl: string;
  bizCreatorSlug: string;
  messageId: number;
  message: string;
  messageStatus: EcItemPurchasedMessageStatusType;
  deliveryStatus: EcItemPurchasedDeliveryStatusType;
  createdAt: string;
  deliveredAt: string;
  messageEndAt: string;
};
